module.exports = __webpack_public_path__ + "static/media/Farm.7f825957.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Farm.jpg
// module id = 253
// module chunks = 0